import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

class EventAssetStore extends ReduceStore{
    getInitialState() {
        return [];
    }

    getByEvent(eventId) {
        return this.getState().filter((e) => e !== undefined && Number(e.eventId) === Number(eventId));
    }

    getIndex(assetId, eventId) {
        return this._state.findIndex((e) => e !== undefined && e.id === Number(assetId) && e.eventId === Number(eventId));
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.EVENT_ASSET_LIST_SUCCESS:
                return update(this.getState(), { $set: action.data});

            case ActionTypes.EVENT_ASSET_ADD_SUCCESS:
                return update(this.getState(), { $push: [action.data]});

            case ActionTypes.EVENT_ASSET_REMOVE_SUCCESS:
                if (action.data) {
                    const index = this.getIndex(action.payload.assetId, action.payload.eventId);
                    return update(this.getState(), { $splice: [[index, 1]] });
                }
                return state;

            default:
                return state;
        }
    }
}

export default new EventAssetStore(CentricDispatcher);
